import { createUseStyles } from 'react-jss'

export const chartColors = {
  perStakeholderImpact: '#D6AD68',
  headcount: '#14332D'
}

const useStyles = createUseStyles({
  graphContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  chartWrapper: {
    maxHeight: props => props.maxHeight || 'auto',
    overflowY: props => (props.isScrollable ? 'auto' : 'visible'),
    overflowX: 'hidden',
    position: 'relative',
    '&::-webkit-scrollbar': {
      width: 8
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: 4
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: 4,
      '&:hover': {
        background: '#555'
      }
    }
  },
  chartCanvas: {
    height: props => props.chartHeight || 'auto'
  },
  legendContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: 84,
    marginTop: 12
  }
})

export default useStyles
